import React, { useEffect, useState, useMemo } from "react";
import { Card, Row, Col, DatePicker, Space, Button, Table, message, Statistic } from "antd";
import moment from "moment";
import axios from "axios";

const { RangePicker } = DatePicker;

const UTIL_BASE_URL = (process.env.REACT_APP_UTIL_URL || "https://utils.clapingo.com").replace(/\/$/, "");

const DemoPaymentDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const columns = useMemo(() => ([
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (val) => (val ? moment(val).format("YYYY-MM-DD HH:mm") : "-")
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (val) => (val != null ? val : "-")
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (_, record) => record?.email || record?.phone || record?.user || "-"
    },
    {
      title: "Order Id",
      dataIndex: "orderId",
      key: "orderId",
    }
  ]), []);

  const normalizeRecords = (records) => {
    if (!Array.isArray(records)) return [];
    return records.map((r, i) => ({
      key: r._id || r.id || i,
      createdAt: r.createdAt || r.date || r.created_at || null,
      amount: r.amount || r.netAmount || r.totalAmount || null,
      currency: r.currency || "INR",
      email: r.email,
      phone: r.phoneNumber || r.phone,
      user: r.user,
      orderId: r.orderId || r.order_id || r.referenceId,
      ...r,
    }));
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const url = `${UTIL_BASE_URL}/api/report/demo-payment-transactions`;
      const res = await axios.post(url, { startDate, endDate });
      const success = res?.data?.success ?? true; // assume success true if not provided
      if (!success) {
        message.error(res?.data?.message || "Failed to fetch data");
        setData([]);
        setLoading(false);
        return;
      }
      const payload = res?.data?.data || res?.data?.transactions || res?.data || [];
      const rows = normalizeRecords(payload);
      setData(rows);
      message.success(res?.data?.message);
    } catch (e) {
      console.error(e);
      message.error(e?.response?.data?.message || "Error fetching data");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const onPick = (dates) => {
    if (dates && dates.length === 2) {
      setStartDate(dates[0].format("YYYY-MM-DD"));
      setEndDate(dates[1].format("YYYY-MM-DD"));
    } else {
      const today = moment().format("YYYY-MM-DD");
      setStartDate(today);
      setEndDate(today);
    }
  };

  // Intentionally do not auto-fetch on mount. Fetch only on Generate button click.
  useEffect(() => {
    // no-op
  }, []);

  const totalAmount = useMemo(() => data.reduce((sum, r) => sum + (Number(r.amount) || 0), 0), [data]);

  return (
    <div style={{ padding: 24 }}>
      <Card title="Demo Payment Transactions">
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col span={12}>
            <Space direction="vertical">
              <span style={{ fontWeight: 500 }}>Select Date Range</span>
              <RangePicker
                format="YYYY-MM-DD"
                value={[moment(startDate, "YYYY-MM-DD"), moment(endDate, "YYYY-MM-DD")]}
                onChange={onPick}
              />
            </Space>
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Space>
              <Button onClick={fetchData} loading={loading} type="primary">Generate</Button>
            </Space>
          </Col>
        </Row>
{/* 
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Card>
              <Statistic title="Total Transactions" value={data.length} loading={loading} />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic title="Total Amount" value={totalAmount} loading={loading} />
            </Card>
          </Col>
        </Row>

        <Table
          loading={loading}
          dataSource={data}
          columns={columns}
          pagination={{ pageSize: 10, showSizeChanger: true }}
          scroll={{ x: 800 }}
        /> */}
      </Card>
    </div>
  );
};

export default DemoPaymentDashboard;
